import { Avatar, Box, Flex, Text } from "@chakra-ui/react";
import { Doughnut } from "react-chartjs-2";

export default function QuestionCard({
  total,
  allTotal,
  questionNumber,
  questionTitle,
  dataAnswers,
  correct,
}) {
  const textPlugin = {
    id: "textPlugin",
    beforeDatasetDraw(chart, args, plugins) {
      const { ctx, data } = chart;
      const xCenter = chart.getDatasetMeta(0).data[0].x;
      const yCenter = chart.getDatasetMeta(0).data[0].y;
      console.log(xCenter);

      ctx.font = "bold 30px sans-serif";
      ctx.fillStyle = "gray";
      ctx.textBaseline = "middle";
      ctx.textAlign = "center";
      const percentage = `${((total / allTotal) * 100).toFixed(0)}%`;
      ctx.fillText(percentage, xCenter, yCenter);
      ctx.restore();
    },
  };
  const data = {
    labels: [],
    datasets: [
      {
        data: [allTotal - total, total],
        backgroundColor: ["#D6D6D600", correct ? "#4DEF86" : "#EF4F67"],
        borderColor: ["#D6D6D600", correct ? "#4DEF86" : "#EF4F67"],
        borderWidth: 1,
        cutout: "80%",
      },
    ],
  };
  return (
    <Flex
      align={"center"}
      rowGap={5}
      direction={"column"}
      p={8}
      bg={"#F9F9F9"}
      w={320}
      className="embla__slide"
    >
      <Box>
        <Text align={"center"}>
          <Avatar
            src={null}
            size="sm"
            name={`Q ${questionNumber}`}
            ml={-1}
            mr={2}
            boxSize="25px"
          />{" "}
          {questionTitle}
        </Text>
      </Box>
      <Text align={"center"} fontWeight={600}>
        {total} alunos (de {allTotal}) {correct ? "acertaram" : "erraram"} essa
        questão!
      </Text>

      <Doughnut plugins={[textPlugin]} data={data} />
    </Flex>
  );
}
